import React from 'react';
import styled from 'styled-components';
import type { TextareaHTMLAttributes } from 'react';
import type { FieldGroupProps } from '../formGroup/types';
import FieldGroup from '../formGroup/FieldGroup';
import { DEFAULT_TRANSITION_DURATION, DEFAULT_TRANSITION_FUNC, getFocusStyle } from '../../util/styled';

type Ref = HTMLTextAreaElement;
type HTMLProps = Omit<TextareaHTMLAttributes<Ref>, 'id' | 'required'>;
interface Props extends HTMLProps, FieldGroupProps {
  id: string;
  label: string;
}

const Textarea = React.forwardRef<Ref, Props>(({
  id,
  label,
  hideLabel,
  required = false,
  isInline = false,
  ...other
}: Props, ref): JSX.Element => (
  <FieldGroup
    id={id}
    required={required}
    label={label}
    hideLabel={hideLabel}
    isInline={isInline}
  >
    <TextareaStyled
      ref={ref}
      id={id}
      name={'name' in other ? other?.name : id}
      aria-label={label}
      className={'appearance-none w-full bg-gray-100 rounded border-transparent p-2'}
      {...other as HTMLProps}
    />
  </FieldGroup>
));

const TextareaStyled = styled('textarea')`
  transition: box-shadow ${DEFAULT_TRANSITION_FUNC} ${DEFAULT_TRANSITION_DURATION};
  &:focus {
    ${(props) => getFocusStyle(props.theme.colors.primary)}
  }
`;

Textarea.displayName = 'Textarea';

export default Textarea;
